













































































































































































































































































































import Vue from "vue";
import Header from "@/components/Header.vue";

interface ResultadoGrasa {
  porcentaje: string;
  categoria: string;
  color: string;
  mensaje: string;
}

export default Vue.extend({
  name: "Grasa-Corporal",
  components: { Header },
  data() {
    return {
      Sexo: null as string | null,
      Altura: null as number | null,
      Cuello: null as number | null,
      Abdomen: null as number | null,
      Cadera: null as number | null,
      resultado: null as ResultadoGrasa | null,
      error: "" as string,
      mostrarRecursos: false,
    };
  },
  computed: {
    sexoOpts(): Array<{ text: string; value: string | null }> {
      return [
        { text: String(this.$t("common.seleccionar")), value: null },
        { text: String(this.$t("common.masculino")), value: "Masculino" },
        { text: String(this.$t("common.femenino")), value: "Femenino" },
      ];
    },
  },
  created() {
    const p = this.$store.state.profile;
    if (p.sexo) this.Sexo = p.sexo;
    if (p.altura) this.Altura = p.altura;
  },
  methods: {
    calcular() {
      this.error = "";
      this.resultado = null;

      if (!this.Sexo) {
        this.error = "Por favor selecciona tu sexo biológico.";
        return;
      }
      if (!this.Altura || !this.Cuello || !this.Abdomen) {
        this.error = "Por favor completa todos los campos requeridos.";
        return;
      }
      if (this.Sexo === "Femenino" && !this.Cadera) {
        this.error =
          "Para mujeres se requiere también el diámetro de la cadera.";
        return;
      }
      if (this.Abdomen <= this.Cuello) {
        this.error = "El abdomen debe ser mayor que el cuello.";
        return;
      }

      let porcentaje: number;

      if (this.Sexo === "Masculino") {
        porcentaje =
          495 /
            (1.0324 -
              0.19077 * Math.log10(this.Abdomen - this.Cuello) +
              0.15456 * Math.log10(this.Altura)) -
          450;
      } else {
        const cadera = this.Cadera as number;
        porcentaje =
          495 /
            (1.29579 -
              0.35004 * Math.log10(this.Abdomen + cadera - this.Cuello) +
              0.221 * Math.log10(this.Altura)) -
          450;
      }

      if (porcentaje < 0 || porcentaje > 70) {
        this.error = this.$t("grasa.error_invalido") as string;
        return;
      }

      const porcentajeStr = porcentaje.toFixed(1);
      let categoria: string;
      let color: string;
      let mensaje: string;

      if (this.Sexo === "Masculino") {
        if (porcentaje < 5) {
          categoria = this.$t("grasa.muy_bajo") as string;
          color = "#F87171";
          mensaje = this.$t("grasa.msg_muy_bajo_h") as string;
        } else if (porcentaje <= 13) {
          categoria = this.$t("grasa.atletico") as string;
          color = "#10B981";
          mensaje = this.$t("grasa.msg_atletico") as string;
        } else if (porcentaje <= 24) {
          categoria = this.$t("grasa.saludable") as string;
          color = "#10B981";
          mensaje = this.$t("grasa.msg_saludable") as string;
        } else {
          categoria = this.$t("grasa.obesidad") as string;
          color = "#F87171";
          mensaje = this.$t("grasa.msg_obesidad") as string;
        }
      } else {
        if (porcentaje < 12) {
          categoria = this.$t("grasa.muy_bajo") as string;
          color = "#F87171";
          mensaje = this.$t("grasa.msg_muy_bajo_f") as string;
        } else if (porcentaje <= 22) {
          categoria = this.$t("grasa.atletico") as string;
          color = "#10B981";
          mensaje = this.$t("grasa.msg_atletico") as string;
        } else if (porcentaje <= 31) {
          categoria = this.$t("grasa.saludable") as string;
          color = "#10B981";
          mensaje = this.$t("grasa.msg_saludable") as string;
        } else {
          categoria = this.$t("grasa.obesidad") as string;
          color = "#F87171";
          mensaje = this.$t("grasa.msg_obesidad") as string;
        }
      }

      this.resultado = { porcentaje: porcentajeStr, categoria, color, mensaje };
      this.$store.commit("setProfile", {
        sexo: this.Sexo,
        altura: this.Altura,
      });
    },
  },
});
